export const ISSUE_CATEGORIES = {
  'Plumbing': [
    'Leak',
    'Burst pipe',
    'Blocked drain / sink / toilet',
    'No water supply',
    'Low water pressure',
    'Tap / fixture issue',
    'Toilet not flushing',
    'Overflow / flooding',
  ],
  'Electrical': [
    'Power outage (partial/full)',
    'Faulty socket / switch',
    'Lighting issue',
    'Fuse box / trip issue',
    'Appliance electrical fault',
    'Burning smell / hazard',
    'Wiring issue',
  ],
  'Heating / Boiler': [
    'No heating',
    'No hot water',
    'Boiler not working',
    'Low pressure in system',
    'Radiator not heating',
    'Thermostat issue',
    'Strange noise from system',
  ],
  'Appliances': [
    'Fridge / freezer not working',
    'Oven / hob issue',
    'Washing machine issue',
    'Dishwasher issue',
    'Extractor fan issue',
    'Dryer issue',
    'General appliance fault',
  ],
  'Structural': [
    'Wall damage / cracks',
    'Ceiling damage',
    'Roof leak',
    'Window damage / drafts',
    'Door damage / misalignment',
    'Floor damage',
    'Insulation issue',
  ],
  'Damp / Mould': [
    'Visible mould',
    'Damp patches',
    'Condensation issue',
    'Musty smell',
    'Water ingress',
  ],
  'Pest Control': [
    'Rodents (rats/mice)',
    'Insects (ants, cockroaches)',
    'Bed bugs',
    'Wasps / bees',
    'Birds nesting',
    'Other pests',
  ],
  'Safety': [
    'Lock issue / broken lock',
    'Door not securing',
    'Smoke alarm fault',
    'CO alarm issue',
    'Fire hazard concern',
    'Security concern',
  ],
  'Cleaning / Waste': [
    'Excess rubbish',
    'Missed bin collection',
    'Need deep cleaning',
    'Hygiene issue',
    'Shared area cleaning',
  ],
  'Garden / Exterior': [
    'Overgrown garden',
    'Fence damage',
    'Drainage outside',
    'External lighting',
    'Pathway / driveway issue',
    'Gutter blockage',
  ],
  'Noise / Neighbour': [
    'Loud neighbours',
    'Anti-social behaviour',
    'Construction noise',
    'Ongoing disturbance',
  ],
  'General Maintenance': [
    'Minor repair needed',
    'Wear and tear',
    'Loose fittings',
    'Cosmetic issue',
  ],
  'Inspection Required': [],
  'Other': [],
};

export const DEFAULT_ISSUE_CATEGORY = 'General Maintenance';
export const ISSUE_CATEGORY_OPTIONS = Object.keys(ISSUE_CATEGORIES);
